export const styleSheet = theme => ({
    container: {
        backgroundColor: theme.colors.gray01,
        display: 'flex',
        justifyContent: 'flex-start',
        padding: '0 3px',
        position: 'relative',
        zIndex: 2
    },
    checkbox: {
        alignItems: 'center',
        backgroundColor: theme.colors.gray10,
        borderRadius: 6,
        color: theme.colors.black01,
        cursor: 'pointer',
        display: 'flex',
        height: 22,
        justifyContent: 'space-between',
        margin: '2px 2px 4px',
        maxWidth: 100,
        padding: '0 5px 0px 4px',
        ':hover': {
            p: {
                color: theme.colors.black01
            }
        },
        p: {
            color: theme.colors.gray06,
            marginLeft: 4
        }
    }
});
